import React from "react";
import { Helmet } from "react-helmet-async";
import imageOverlay from "../img/train.jpg";

class InternTraining extends React.Component {
  render() {
    return (
      <section
        className="paralax-mf footer-paralax bg-image sect-mt4 route"
        style={{ backgroundImage: `url(${imageOverlay})` }}
      >
        {/* SEO Meta Tags */}
        <Helmet>
          <title>Internships & Training | Ethervue Pvt Ltd</title>
          <meta 
            name="description" 
            content="Boost your career with Ethervue's training programs in IT, Decision Science, and Participatory Irrigation Management. Industry-relevant skills and certified internships available." 
          />
          <meta 
            name="keywords" 
            content="Ethervue, Internships, IT Training, Decision Science, Irrigation Management, Industry Skills, Certified Training, Career Growth" 
          />
          <meta name="author" content="Ethervue Pvt Ltd" />

          {/* Open Graph for Social Media */}
          <meta property="og:title" content="Internships & Training | Ethervue Pvt Ltd" />
          <meta 
            property="og:description" 
            content="Join Ethervue's industry-ready training programs and certified internships to accelerate your career." 
          />
          <meta property="og:image" content="https://ethervue.in/img/train.jpg" />
          <meta property="og:url" content="https://ethervue.in/InternTraining" />
          <meta property="og:type" content="website" />

          {/* Twitter Card */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Internships & Training | Ethervue Pvt Ltd" />
          <meta name="twitter:description" content="Get industry-ready with Ethervue's specialized training and internships." />
          <meta name="twitter:image" content="https://ethervue.in/img/train.jpg" />
        </Helmet>

        <div className="overlay-mf"></div>
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="InternTraining-mf">
                <div id="InternTraining" className="box-shadow-full">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="title-box-2">
                        <h5 className="title-left">Send A Message</h5>
                      </div>
                      <div>
                        <form
                          action="https://formspree.io/f/maneyjpp"
                          method="POST"
                          className="InternTrainingForm"
                        >
                          <div id="sendmessage">
                            Your message has been sent. Thank you!
                          </div>
                          <div id="errormessage"></div>
                          <div className="row">
                            <div className="col-md-12 mb-3">
                              <div className="form-group">
                                <input
                                  type="text"
                                  name="name"
                                  className="form-control"
                                  id="name"
                                  placeholder="Your Name"
                                />
                              </div>
                            </div>
                            <div className="col-md-12 mb-3">
                              <div className="form-group">
                                <input
                                  type="email"
                                  className="form-control"
                                  name="email"
                                  id="email"
                                  placeholder="Your Email"
                                />
                              </div>
                            </div>
                            <div className="col-md-12 mb-3">
                              <div className="form-group">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="subject"
                                  id="subject"
                                  placeholder="Subject"
                                />
                              </div>
                            </div>
                            <div className="col-md-12 mb-3">
                              <div className="form-group">
                                <textarea
                                  className="form-control"
                                  name="message"
                                  rows="5"
                                  placeholder="Message"
                                ></textarea>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <button
                                type="submit"
                                className="button button-a button-big button-rouded"
                              >
                                Send Message
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="title-box-2 pt-4 pt-md-0">
                        <h5 className="title-left">Internships and Trainings</h5>
                      </div>
                      <div className="more-info">
                        <p className="lead">
                          Revolutionize your career with our industry-focused training in Information Technology, Decision Science, and Participatory Irrigation Management. Our programs are designed to provide the skills needed to be job-ready from day one.
                          <br />
                          We also offer certified project-based internships for students, equipping them with hands-on experience in real-world scenarios.
                          <br />
                          Contact us via the form above, our social media, or email us at ethervuepvtltd@gmail.com.
                        </p>
                      </div>
                      <div className="socials">
                        <ul>
                          <li>
                            <a
                              href="https://www.linkedin.com/company/ethervue/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <span className="ico-circle">
                                <i className="ion-social-linkedin"></i>
                              </span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://www.facebook.com/people/Ethervue/61573813097914/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <span className="ico-circle">
                                <i className="ion-social-facebook"></i>
                              </span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://www.instagram.com/ethervuepvtltd/profilecard/?igsh=azVsb3Mya2ZnMmtl"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <span className="ico-circle">
                                <i className="ion-social-instagram"></i>
                              </span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="copyright-box"></div>
              </div>
            </div>
          </div>
        </footer>
      </section>
    );
  }
}

export default InternTraining;
